import { DesktopMenu } from './DesktopMenu';

export default DesktopMenu;
export type { DesktopMenuProps } from './types';
